export const mainWebsiteUrl = "https://cinrisk.com";
